import PropTypes from 'prop-types';
import { memo } from 'react';

import Heading from 'shopper/components/Heading';
import Link from 'shopper/components/Link';

import Image from 'components/Image';

import { sendEvent } from 'lib/gtag';
import { getArticleImageLink, toArticleImageAltText } from 'lib/image';
import { toArticleLink } from 'lib/links';

const ArticleCard = ({
  articleSlug,
  articleThumbnail,
  articleTitle,
  gaEventCategory,
}) => {
  const onClickHandler = () => {
    sendEvent({
      action: 'click_blogspot_post_lp',
      category: gaEventCategory,
      label: articleSlug,
    });
  };

  return (
    <Link
      className="flex flex-col items-center gap-4 hover:no-underline sm:w-auto"
      href={toArticleLink(articleSlug)}
      rel="noopener noreferrer"
      target="_blank"
      onClick={onClickHandler}
    >
      <Image
        alt={toArticleImageAltText(articleTitle)}
        className="h-auto w-full md:w-[340px] lg:w-full"
        height={260}
        src={getArticleImageLink(articleThumbnail, 400)}
        width={400}
      />
      <Heading className="line-clamp-2" size="size5">
        {articleTitle}
      </Heading>
    </Link>
  );
};

ArticleCard.propTypes = {
  articleSlug: PropTypes.string.isRequired,
  articleThumbnail: PropTypes.string.isRequired,
  articleTitle: PropTypes.string.isRequired,
  gaEventCategory: PropTypes.string.isRequired,
};

export default memo(ArticleCard);
